import { SCREEN_SIZES } from 'modules/utils/screenSizes';
import { useMediaQuery } from 'react-responsive';
import { DesktopFooter } from './Footer.desktop';
import { MobileFooter } from './Footer.mobile';

export const Footer = () => {
  const isMobile = useMediaQuery({
    query: `(max-width: ${SCREEN_SIZES.mobile})`,
  });

  if (isMobile) return <MobileFooter />;

  return <DesktopFooter />;
};
